import img from '../../assets/login-bg.jpg';
import flex from '../../styles/flex';
import palette from '../../styles/palette';

const styles = {
    sideBarWrapper: {
        ...flex.flexFill,
        backgroundColor: palette.bg.primary,
        maxWidth: 640,
        width: "40%",
        minWidth: 400,
        minHeight: "100%",
        display: "flex",
        alignItems: "center"
    } as React.CSSProperties,
    sideBarWrapperSmall: {
        backgroundColor: palette.bg.primary,
        paddingTop: "2rem",
        maxWidth: "unset",
        width: "100%",
        minWidth: "auto",
        minHeight: "auto",

    } as React.CSSProperties,
    sideBar: {
        paddingLeft: "4rem", paddingRight: "4rem"
    } as React.CSSProperties,
    sideBarSmall: {
        paddingLeft: "2rem", paddingRight: "2rem",
    } as React.CSSProperties,
    title: {
        textAlign: "left",
        color: palette.text.primary,
        fontSize: 72,
        fontWeight: 600,
        margin: 0
    } as React.CSSProperties,
    message: {
        textAlign: "left",
        color: palette.text.secondary,
        fontSize: 24,
        fontWeight: 600,
    } as React.CSSProperties,
    background: {
        backgroundColor: "rgb(235, 48, 79)",
        backgroundImage: `url('${img}')`,
        backgroundSize: 'auto 100%',
        backgroundPosition: 'right center',
        backgroundRepeat: 'no-repeat',
    } as React.CSSProperties,
    backgroundSmall: {
        height: "35vh",
        backgroundPosition: 'center center',
    } as React.CSSProperties,
    row: {
        paddingBottom: 20
    },
    field: {
        width: "100%",
        maxWidth: 300
    } as React.CSSProperties,
    fieldSm: {
        maxWidth: "unset",

    } as React.CSSProperties,
    buttons: {
        primary: {
            marginLeft: 10,
            marginBottom: 10
        },
        secondary: {
            marginLeft:10,
            marginBottom: 10
        }
    },
    alignRightSm:{
        textAlign:"right",
    } as React.CSSProperties,
    alignRight:{
        textAlign:"right",
        maxWidth: 300
    } as React.CSSProperties,
    errorRow: {
        color: "red"
  
    } as React.CSSProperties,
    footer: {
        position: "fixed",
        bottom: 0,
        left: 0,
        height: 88,
        zIndex: 1000000,
        maxWidth: 640,
        width: "40%",
        minWidth: 400,
        backgroundColor: "rgb(184, 156, 160)",
        ...flex.flexFill
    } as React.CSSProperties,
    webFooter: {

    } as React.CSSProperties,
    tabletFooter: {
        paddingBottom: 5,
        maxWidth: "none",
        minWidth: "none",
        width: "100vw",
        backgroundColor: "rgb(184, 156, 160)",
    } as React.CSSProperties
};
export default styles;